import { FileText, Building2, Cpu, TableProperties } from 'lucide-react';

export function JobStatsRow({ job }) {
  const stats = [
    { icon: FileText, label: 'Sheets', value: job.sheet_count },
    { icon: Building2, label: 'Spaces', value: job.space_count },
    { icon: Cpu, label: 'Assets', value: job.asset_count },
    { icon: TableProperties, label: 'Schedules', value: job.schedule_count },
  ];

  return (
    <div className="grid grid-cols-4 gap-4 mb-6" data-testid="job-stats-row">
      {stats.map((s) => (
        <div key={s.label} className="bg-card border border-border rounded-sm px-4 py-3 flex items-center gap-3">
          <s.icon className="w-4 h-4 text-muted-foreground" />
          <div>
            <span className="font-heading text-[10px] uppercase tracking-widest text-muted-foreground block">{s.label}</span>
            <span className="font-mono text-lg font-bold text-foreground">{s.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
